import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import lazyImport from '@Utils/lazyImport';

import { RouteInfo } from '../appRoutes';

const MarketplacePage = lazyImport(() => import('./MarketPlacePage'));

const routes: RouteInfo[] = [
  {
    path: RouteConfig.Marketplace.template,
    component: MarketplacePage,
    title: Messages.marketPlace,
    exact: false,
  },
];

export default routes;
